import { render, staticRenderFns } from "./PrettyJSON.vue?vue&type=template&id=4be41a9b&scoped=true&"
import script from "./PrettyJSON.vue?vue&type=script&lang=js&"
export * from "./PrettyJSON.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be41a9b",
  null
  
)

export default component.exports